
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { FeedbackMessage, NewFeedbackMessage } from "@/types/feedback";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export const useCreateMessage = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  
  const createMessage = useMutation({
    mutationFn: async (newMessage: NewFeedbackMessage) => {
      if (!user) {
        throw new Error("Je moet ingelogd zijn om een bericht te plaatsen");
      }

      const { data, error } = await supabase
        .from('feedback_messages')
        .insert({
          message: newMessage.message,
          user_id: newMessage.user_id,
          username: newMessage.username,
          parent_id: newMessage.parent_id || null,
          category_tag: newMessage.category_tag || null,
          attachment_path: newMessage.attachment_path || null,
        })
        .select()
        .single();
      
      if (error) throw error;
      return data as FeedbackMessage;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['feedback-messages'] });
      toast.success('Bericht succesvol geplaatst');
    },
    onError: (error) => {
      console.error('Error creating feedback message:', error);
      toast.error('Fout bij het plaatsen van bericht');
    }
  });

  return { createMessage, user };
};
